import Boto from 'components/3catinfo/Boto';
import styles from './botonsPrevisio.module.scss';
import Slider from 'components/3catinfo/Slider';

const BotonsPrevisio = (props) => {
    const seccio = props?.routerQuery?.slug;
    return (
        <Slider tipus='menu' className={styles.contentButtons}>
            <Boto
                route={{ slug: 'nuvols', type: 'web_3catinfo_el_temps_previsio' }}
                text='Núvols'
                className={`${styles.boto} ${seccio === 'nuvols' ? styles.selected : ''}`}
                tagLabel={seccio === 'nuvols' && 'h1'}
            />
            <Boto
                route={{ slug: 'pluges', type: 'web_3catinfo_el_temps_previsio' }}
                text='Pluges'
                className={`${styles.boto} ${seccio === 'pluges' ? styles.selected : ''}`}
                tagLabel={seccio === 'pluges' && 'h1'}
            />
            <Boto
                route={{ slug: 'temperatures', type: 'web_3catinfo_el_temps_previsio' }}
                text='Temperatures'
                className={`${styles.boto} ${seccio === 'temperatures' ? styles.selected : ''}`}
                tagLabel={seccio === 'temperatures' && 'h1'}
            />
            <Boto
                route={{ slug: 'comparativa-temperatures', type: 'web_3catinfo_el_temps_previsio' }}
                text='Comparativa temperatures'
                className={`${styles.boto} ${seccio === 'comparativa-temperatures' ? styles.selected : ''}`}
                tagLabel={seccio === 'comparativa-temperatures' && 'h1'}
            />
            <Boto
                route={{ slug: 'vents', type: 'web_3catinfo_el_temps_previsio' }}
                text='Vents'
                className={`${styles.boto} ${seccio === 'vents' ? styles.selected : ''}`}
                tagLabel={seccio === 'vents' && 'h1'}
            />
            <Boto
                route={{ slug: 'cops-de-vent', type: 'web_3catinfo_el_temps_previsio' }}
                text='Cops de vent'
                className={`${styles.boto} ${seccio === 'cops-de-vent' ? styles.selected : ''}`}
                tagLabel={seccio === 'cops-de-vent' && 'h1'}
            />
        </Slider>
    );
};

export default BotonsPrevisio;
